export type PointerState = {
  x: number;
  y: number;
  /** Last time the pointer moved (performance.now()). */
  lastActive: number;
  hasPosition: boolean;
};

export function createPointer(target: HTMLElement | Window = window): {
  state: PointerState;
  dispose: () => void;
} {
  const state: PointerState = {
    x: typeof window !== "undefined" ? window.innerWidth / 2 : 0,
    y: typeof window !== "undefined" ? window.innerHeight / 2 : 0,
    lastActive: 0,
    hasPosition: false,
  };

  const onMove = (e: PointerEvent) => {
    state.x = e.clientX;
    state.y = e.clientY;
    state.lastActive = performance.now();
    state.hasPosition = true;
  };

  const onTouch = (e: TouchEvent) => {
    const t = e.touches[0];
    if (!t) return;
    state.x = t.clientX;
    state.y = t.clientY;
    state.lastActive = performance.now();
    state.hasPosition = true;
  };

  target.addEventListener("pointermove", onMove as EventListener, {
    passive: true,
  });
  target.addEventListener("touchmove", onTouch as EventListener, {
    passive: true,
  });
  target.addEventListener("pointerdown", onMove as EventListener, {
    passive: true,
  });

  return {
    state,
    dispose: () => {
      target.removeEventListener("pointermove", onMove as EventListener);
      target.removeEventListener("touchmove", onTouch as EventListener);
      target.removeEventListener("pointerdown", onMove as EventListener);
    },
  };
}

export function isPointerActive(
  state: PointerState,
  now: number,
  idleMs = 2500,
): boolean {
  if (!state.hasPosition) return false;
  return now - state.lastActive < idleMs;
}
